module.exports = __webpack_public_path__ + "static/media/scissors.373b9e2b.svg";